import { ColumnMaps } from '@/components/GraphqlDataTable/columns/types'
import HireColumns from '@/components/GraphqlDataTable/columns/Hire'
import JobColumns from '@/components/GraphqlDataTable/columns/Job'

const columns: ColumnMaps = {
  ...HireColumns,
  ...JobColumns,
}
export default columns
